/**
 * Status display config for review (label + Tailwind classes).
 * UX: consistent status colors and Polish labels.
 */
export const REVIEW_STATUS_CONFIG = {
  accepted: { label: 'Zaakceptowane', className: 'bg-green-100 text-green-800' },
  rejected: { label: 'Odrzucone', className: 'bg-red-100 text-red-800' },
  recontact: { label: 'Do kontaktu', className: 'bg-blue-100 text-blue-800' },
  pending: { label: 'Do weryfikacji', className: 'bg-yellow-100 text-yellow-800' },
};

/**
 * @param {string} status
 * @returns {{ label: string, className: string }}
 */
export function getReviewStatusDisplay(status) {
  return (
    REVIEW_STATUS_CONFIG[status] ||
    REVIEW_STATUS_CONFIG.pending
  );
}
